import * as React from 'react';
import { useEffect, useState, useRef } from 'react';
import useReduxState from 'src/hooks/useReduxState';
import ProductRepository from 'src/repository/ProductRepository';
import System from "../../../helper/system";
import { isString } from "underscore";
import $ from "jquery";
import { useAxiosIndicatorCheck } from "../../../store/hook/useAxiosIndicatorCheck";
import Common from '../Cart/Common';
import ShowMoreLess from 'src/component/Product/ShowMoreLess';
import { __remove, __set } from 'src/store/axios_indicator';
import { useProductPricingStore } from 'src/hooks/productPricing';

const AddPartAutoComplete = (props) => {
    const wrapperRef = useRef(null);
    const [__check] = useAxiosIndicatorCheck();
    const isPriceInventoryCall = props.isPriceInventoryCall != undefined ? props.isPriceInventoryCall : true;
    const [searchTerm, setSearchTerm] = useReduxState('', 'setAutoCompleteSearchTerm')
    const [keyPress, setKeyPress] = useState(false)
    const clsClose = "dropdown search-part w280 "
    const clsOpen = clsClose + "open";
    const [classToToggle, setClassToToggle] = useState(clsClose);
    const [productListGroup, setProductListGroup] = useState({});
    const [productList, setProductList] = useState({});
    const [backButtonClick, setBackButtonClick] = useState(false)
    const [productSelected, setProductSelected] = useReduxState({}, 'setAutoCompleteProductSelected')
    const [{ pricingList }, { }, { }] = useProductPricingStore();

    useEffect(() => {
        async function fetchHere() {
            $(document).on('click', '.dropdown-menu', function (e) {
                e.stopPropagation();
            });

            document.addEventListener("click", handleClickOutside, false);
            return () => {
                document.removeEventListener("click", handleClickOutside, false);
            };
        }

        fetchHere()
    }, []);

    useEffect(() => {

        if (searchTerm.trim().length === 0) {
            setClassToToggle(clsClose)
        }

        const delayDebounceFn = setTimeout(async () => {
            // after product selection it'll not going to trigger API
            if (searchTerm !== false && searchTerm.length > 2 && keyPress === true) {
                await typingCompleted(searchTerm)
                setKeyPress(false)
            }
        }, 1000);

        return () => clearTimeout(delayDebounceFn)

    }, [searchTerm, keyPress]);

    const handleClickOutside = event => {
        if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
            setClassToToggle(clsClose)
        }
    };

    const typingCompleted = async (searchTerm) => {
        let res = await fetchFromServer(searchTerm);
        setProductListGroup(res);
        setProductList({});
        if (searchTerm.length < 1) {
            setClassToToggle(clsClose)
            await setProductListGroup({})
        }
    };

    useEffect(() => {
        if (backButtonClick) {
            let manualPartElem = document.getElementById('manual-add-part-box');
            if (manualPartElem !== undefined && manualPartElem !== null) {
                if (manualPartElem.classList !== undefined && !manualPartElem.classList.contains('open')) {
                    manualPartElem.removeAttribute('class');
                    manualPartElem.setAttribute('class', clsOpen);
                }
                setBackButtonClick(false);
            }
        }
    }, [backButtonClick])

    const selectProduct = async (productHere) => {
        /**
         * Ticket    : 11838
         * Change    : Add Axios Slug Flag for managing loader when clicking on multiple products
         * Change by : Pankaj
         * Date      : 01 June 2023
         */
        __set('MANUAL_SEARCH_API_CALL')
        if (productHere.Count !== undefined && productHere.Count > 1) {
            setTimeout(() => {
                // Ticket : 9915 Change : Added code below to validate the class and re-apply if not exist
                let manualPartElem = document.getElementById('manual-add-part-box');
                if (manualPartElem) {
                    manualPartElem.removeAttribute('class');
                    manualPartElem.setAttribute('class', clsOpen);
                }
            }, 1200);
            let res = await new ProductRepository().fetchGroupedProductsObjectBySearchParam(productHere.ERPMFRPartNumber, productHere.ManufacturerName, false, true);
            setProductList(res);
            //added by Ramya
            addPartEvent();

        } else if (productHere.ERPPartNumber) {
            {/**
            * isPriceInventoryCall is used for reduce price and inventory call if it's false then not calling API
            * Author: Devanshi Patel
            */}
            let p = await new ProductRepository().fetchProductObjectByERPPartNumbersNew(productHere.ERPPartNumber, isPriceInventoryCall, true, true, searchTerm);

            if (p[productHere.ERPPartNumber] !== undefined) {
                let selectedSearchCPN = ''
                if (p[productHere.ERPPartNumber]?.CustomerPartNumbers && p[productHere.ERPPartNumber]?.CustomerPartNumbers?.length > 0) {
                    selectedSearchCPN = await new ProductRepository().checkCPNAvailableInList(p[productHere.ERPPartNumber]?.CustomerPartNumbers, searchTerm);
                }
                setProductSelected({ ...p[productHere.ERPPartNumber], "selectedSearchCPN": selectedSearchCPN });
                setClassToToggle(clsClose);
                if (p[productHere.ERPPartNumber].ERPMFRPartNumber !== undefined && p[productHere.ERPPartNumber].ERPMFRPartNumber !== null) {
                    setSearchTerm(p[productHere.ERPPartNumber].ERPMFRPartNumber); //After Product Set That Part number in search
                }
                //added by Ramya
                addPartEvent(p[productHere.ERPPartNumber]);
            } else {
                setProductSelected({});
                System.alert('Main API is not giving Product Detailed data. on:' + productHere.ERPPartNumber, 'danger');
                setClassToToggle(clsOpen)
            }
        }
        __remove('MANUAL_SEARCH_API_CALL')
    };

    
    //By Ramya Kannan [Quickly add a part - Adobe script ]
   function addPartEvent(prodData){
    if(Object.keys(prodData).length){
        localStorage.setItem("prodPayload",JSON.stringify(prodData));
        localStorage.setItem("adobeEventType","bomQuicklyAddPart");
    }
   
}

    const fetchFromServer = async (searchTermHere) => {
        if (isString(searchTermHere)) {
            searchTermHere = searchTermHere.trim()
        }
        let res = await new ProductRepository().fetchGroupedProductsObjectBySearchParam(searchTermHere);
        if (Object.keys(res).length > 0) {
            setClassToToggle(clsOpen)
        } else {
            setClassToToggle(clsClose)
        }
        if (!(res && Object.entries(res).length > 0)) {
            setClassToToggle(clsOpen)
        }
        return res;
    };

    const displayClearIconStatus = () => {
        return false;
    };

    const getSearchStringBold = (string) => {
        return (
            <>
                {isString(string) &&
                    <div
                        dangerouslySetInnerHTML={{ __html: string.toUpperCase().replaceAll(searchTerm.toUpperCase(), "<span className='text-blue2'>" + searchTerm.toUpperCase() + "</span>") }} />
                }
            </>
        )
    };

    const getProductGroupItem = (productListHere) => {
        return (
            <>
                {
                    productListHere && Object.keys(productListHere).map((p) => (
                        <li key={p} onClick={async () => {
                            await selectProduct(productListHere[p])
                        }}>
                            {!__check(['PRODUCT_MANUAL_SEARCH_LISTING_API_CALL', 'PRODUCT_PRICING_API_CALL', 'PRODUCT_INVENTORY_API_CALL']).status &&
                                <>
                                    <div className="product-part-name">
                                        <span>
                                            <>
                                                {getSearchStringBold(productListHere[p].ERPMFRPartNumber)}
                                            </>
                                        </span>
                                    </div>
                                    <div className="product-part-detail">
                                        <div className="text-black">
                                            <span className="text-black">
                                                {productListHere[p].ManufacturerName ? productListHere[p].ManufacturerName : ''}
                                            </span>
                                        </div>
                                        {productListHere[p].Count > 1 &&
                                            <div className="text-black">
                                                <div>
                                                    {productListHere[p].Count} products found
                                                    in {productListHere[p].ManufacturerName}
                                                </div>
                                            </div>
                                        }

                                        {productListHere[p].Count <= 1 &&
                                            <div>
                                                {productListHere[p].ShortDescription ?
                                                    <ShowMoreLess single_product={productListHere[p]} /> : ''
                                                }
                                            </div>
                                        }
                                    </div>
                                </>
                            }

                        </li>
                    ))
                }
                {!(productListHere && Object.entries(productListHere).length > 0) &&
                    !__check(['PRODUCT_MANUAL_SEARCH_LISTING_API_CALL', 'PRODUCT_PRICING_API_CALL', 'PRODUCT_INVENTORY_API_CALL']).status &&
                    <li>
                        <div className="no-part-data">
                            {!__check(['PRODUCT_MANUAL_SEARCH_LISTING_API_CALL', 'PRODUCT_PRICING_API_CALL', 'PRODUCT_INVENTORY_API_CALL']).status &&
                                <>(0) Results Found</>
                            }
                        </div>
                    </li>
                }
            </>
        )
    };

    const getPricing = (ERPMFRPartNumber, ERPPartNumber,ERPPartNumberModified) => {
        ERPPartNumber = ERPPartNumberModified ? '' : ERPPartNumber; 
        if (pricingList[ERPMFRPartNumber + '-' + ERPPartNumber]) {
            return pricingList[ERPMFRPartNumber + '-' + ERPPartNumber];
        }
        return [];
    };

    const getProductItem = (productListHere) => {
        return (
            <>
                {
                    productListHere && Object.keys(productListHere).map((p) => (
                        <li key={p} onClick={async () => {
                            await selectProduct(productListHere[p])
                        }}>
                            <>
                                <div className="product-part-name">
                                    <span>
                                        {getSearchStringBold(productListHere[p].ERPMFRPartNumber && productListHere[p].ERPMFRPartNumber !== null && productListHere[p].ERPMFRPartNumber.trim() !== '' ? productListHere[p].ERPMFRPartNumber : '')}
                                    </span>
                                </div>
                                <div className="product-part-detail">
                                    <div className="text-black">
                                        {new Common().template_for_add_part_pricing(getPricing(productListHere[p].ERPMFRPartNumber, productListHere[p].ERPPartNumber, productListHere[p].ERPPartNumberModified))}
                                    </div>
                                    <div className='mt-2'>
                                        {productListHere[p].ShortDescription && productListHere[p].ShortDescription !== undefined && productListHere[p].ShortDescription !== null && productListHere[p].ShortDescription.trim() != '' ?
                                            <ShowMoreLess single_product={productListHere[p]} /> : ''
                                        }
                                    </div>

                                    <div className='mt-4'>
                                        {productListHere[p].PackagingTypeCode && productListHere[p].PackagingTypeCode !== undefined ?
                                            productListHere[p].PackagingTypeCode : ''
                                        }
                                    </div>
                                </div>
                            </>
                        </li>
                    ))
                }
                {!(productListHere && Object.entries(productListHere).length > 0) &&
                    <li>
                        <div className="no-part-data">
                            {__check(['PRODUCT_MANUAL_SEARCH_LISTING_API_CALL', 'PRODUCT_PRICING_API_CALL', 'PRODUCT_INVENTORY_API_CALL']).status &&
                                <i className="cursor-pointer fa fa-spinner fa-spin" />
                            }
                            {!__check(['PRODUCT_MANUAL_SEARCH_LISTING_API_CALL', 'PRODUCT_PRICING_API_CALL', 'PRODUCT_INVENTORY_API_CALL']).status &&
                                <>(0)</>
                            } Results Found
                        </div>
                    </li>
                }
            </>
        )
    };
    return (
        <>
            <div id="manual-add-part-box" className={classToToggle} ref={wrapperRef}>
                <div className='position-relative'>
                    <input className="cart-head-input h30" type="text" placeholder="Type Part Number"
                        value={(productSelected && productSelected.ERPMFRPartNumber) ? productSelected.ERPMFRPartNumber : searchTerm ? searchTerm : ''}
                        autoComplete={'off'}
                        onChange={(e) => {
                            setSearchTerm(e.target.value)
                        }}
                        onPaste={(e) => {
                            setSearchTerm('');
                            setProductSelected({})
                        }}
                        onKeyUp={(e) => {
                            setKeyPress(true)
                            setProductSelected({})
                        }}
                    />
                    {/*--------------clear-icon*/}

                    {!__check(['PRODUCT_MANUAL_SEARCH_LISTING_API_CALL', 'PRODUCT_PRICING_API_CALL', 'PRODUCT_INVENTORY_API_CALL']).status && displayClearIconStatus() &&
                        <i onClick={async () => {
                            await setProductListGroup({});
                            setSearchTerm('')
                            setProductSelected({})
                            setClassToToggle(clsClose)
                        }}
                            className="cursor-pointer fa fa-times-circle input-close" />}
                    {__check(['PRODUCT_MANUAL_SEARCH_LISTING_API_CALL', 'MANUAL_SEARCH_API_CALL']).status &&
                        <i className="cursor-pointer input-close fa fa-spinner fa-spin"
                        />
                    }
                </div>
                <div className="dropdown-menu search-part-dropdown search-part-cart-dropdown"
                    aria-labelledby="search-dropdown">
                    {Object.entries(productList).length > 1 &&
                        <>
                            <div className="more-products-step">
                                <button type='button' className='more-products-step-back bg-transparent' onClick={() => {
                                    setClassToToggle(clsOpen); // re-open list
                                    setProductList({});
                                    setTimeout(() => {
                                        setBackButtonClick(true);
                                    }, 800)
                                }}>
                                    <a className='text-blue2' href={void (0)}>
                                        <i className='fa fa-arrow-circle-left me-1'></i>
                                        <span>Back</span>
                                    </a>
                                </button>
                                <div className='more-products-step-info'>
                                    ({Object.entries(productList).length}) Products found
                                    in {productList[0].ManufacturerName}
                                </div>
                                <ul>
                                    <>
                                        {getProductItem(productList)}
                                    </>
                                </ul>
                            </div>
                        </>
                    }
                    {__check(['PRODUCT_MANUAL_SEARCH_LISTING_API_CALL', 'PRODUCT_PRICING_API_CALL', 'PRODUCT_INVENTORY_API_CALL']).render}
                    {Object.entries(productList).length < 1 &&
                        <ul className={Object.entries(productListGroup).length > 5 ? 'auto-search-scroll' : ''}>
                            <>
                                {getProductGroupItem(productListGroup)}
                            </>
                        </ul>
                    }
                </div>
            </div>
        </>
    );
};

export default AddPartAutoComplete;